// src/components/tableros/constants/themes.js - Con tipografías personalizadas para cada tema
export const themes = {
  classic: {
    // Colores
    tableBackgroundColor: '#1a1a1a',
    globalFontColor: '#ffffff',
    headerBackgroundColor: '#2c0369',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#4c516d',
    positionColor: '#ffffff',
    positionBackgroundColor: '#4c516d',
    nameBackgroundColor: '#515e7b',
    athleteNameColor: '#ffffff',
    teamNameColor: '#e0e0e0',
    markBackgroundColor: '#000000',
    resultTimeColor: '#ffffff',
    timerColor: '#00ff00',
    largeTimerColor: '#00ff00',
    tableRowOddColor: '#252525',
    tableRowEvenColor: '#1e1e1e',
    deltaTimeColor: '#c1ff30',
    attemptColor: '#ffffff',
    attemptBackgroundColor: '#0d47a1',
    laneColor: '#ffffff',
    numberColor: '#ffffff',
    lastLapTimeColor: '#ffffff',
    reactionTimeColor: '#ffffff',
    lapsToGoColor: '#ffffff',
    lapsColumnsColor: '#ffffff',
    // Colores específicos para campo vertical
    failColor: '#b71c1c',
    passColor: '#0d47a1',
    successColor: '#1b5e20',
    // Tipografía
    headerFontFamily: 'Roboto',
    nameFontFamily: 'Roboto',
    numbersFontFamily: 'Roboto Mono'
  },
  
  light: {
    // Colores
    tableBackgroundColor: '#ffffff',
    globalFontColor: '#333333',
    headerBackgroundColor: '#4a86e8',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#e8f0fe',
    positionColor: '#333333',
    positionBackgroundColor: '#f1f3f4',
    nameBackgroundColor: '#e8f0fe',
    athleteNameColor: '#333333',
    teamNameColor: '#757575',
    markBackgroundColor: '#f9f9f9',
    resultTimeColor: '#333333',
    timerColor: '#4a86e8',
    largeTimerColor: '#4a86e8',
    tableRowOddColor: '#f9f9f9',
    tableRowEvenColor: '#ffffff',
    deltaTimeColor: '#4caf50',
    attemptColor: '#333333',
    attemptBackgroundColor: '#bbdefb',
    laneColor: '#333333',
    numberColor: '#333333',
    lastLapTimeColor: '#333333',
    reactionTimeColor: '#333333',
    lapsToGoColor: '#333333',
    lapsColumnsColor: '#333333',
    failColor: '#e57373',
    passColor: '#64b5f6',
    successColor: '#81c784',
    // Tipografía
    headerFontFamily: 'Open Sans',
    nameFontFamily: 'Open Sans',
    numbersFontFamily: 'IBM Plex Mono'
  },
  
  dark: {
    // Colores
    tableBackgroundColor: '#121212',
    globalFontColor: '#e0e0e0',
    headerBackgroundColor: '#1e1e1e',
    headerFontColor: '#e0e0e0',
    columnsHeaderColor: '#2a2a2a',
    positionColor: '#e0e0e0',
    positionBackgroundColor: '#333333',
    nameBackgroundColor: '#333333',
    athleteNameColor: '#e0e0e0',
    teamNameColor: '#bdbdbd',
    markBackgroundColor: '#1e1e1e',
    resultTimeColor: '#e0e0e0',
    timerColor: '#4fc3f7',
    largeTimerColor: '#4fc3f7',
    tableRowOddColor: '#1a1a1a',
    tableRowEvenColor: '#121212',
    deltaTimeColor: '#4fc3f7',
    attemptColor: '#e0e0e0',
    attemptBackgroundColor: '#333333',
    laneColor: '#e0e0e0',
    numberColor: '#e0e0e0',
    lastLapTimeColor: '#e0e0e0',
    reactionTimeColor: '#e0e0e0',
    lapsToGoColor: '#e0e0e0',
    lapsColumnsColor: '#e0e0e0',
    failColor: '#b71c1c',
    passColor: '#0d47a1',
    successColor: '#1b5e20',
    // Tipografía
    headerFontFamily: 'Inter',
    nameFontFamily: 'Inter',
    numbersFontFamily: 'Roboto Mono'
  },
  
  olympic: {
    // Colores
    tableBackgroundColor: '#0a2351',
    globalFontColor: '#ffffff',
    headerBackgroundColor: '#0066b3',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#1c3d7c',
    positionColor: '#ffffff',
    positionBackgroundColor: '#1c3d7c',
    nameBackgroundColor: '#1c3d7c',
    athleteNameColor: '#ffffff',
    teamNameColor: '#ffd700',
    markBackgroundColor: '#0a2351',
    resultTimeColor: '#ffd700',
    timerColor: '#ffd700',
    largeTimerColor: '#ffd700',
    tableRowOddColor: '#0a2351',
    tableRowEvenColor: '#102d65',
    deltaTimeColor: '#ffd700',
    attemptColor: '#ffffff',
    attemptBackgroundColor: '#0066b3',
    laneColor: '#ffffff',
    numberColor: '#ffffff',
    lastLapTimeColor: '#ffffff',
    reactionTimeColor: '#ffffff',
    lapsToGoColor: '#ffffff',
    lapsColumnsColor: '#ffffff',
    failColor: '#f44336',
    passColor: '#2196f3',
    successColor: '#4caf50',
    // Tipografía
    headerFontFamily: 'Montserrat',
    nameFontFamily: 'Montserrat',
    numbersFontFamily: 'Roboto Mono'
  },
  
  stadium: {
    // Colores
    tableBackgroundColor: '#1b5e20',
    globalFontColor: '#ffffff',
    headerBackgroundColor: '#2e7d32',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#388e3c',
    positionColor: '#ffffff',
    positionBackgroundColor: '#388e3c',
    nameBackgroundColor: '#388e3c',
    athleteNameColor: '#ffffff',
    teamNameColor: '#c8e6c9',
    markBackgroundColor: '#1b5e20',
    resultTimeColor: '#ffffff',
    timerColor: '#ffeb3b',
    largeTimerColor: '#ffeb3b',
    tableRowOddColor: '#1b5e20',
    tableRowEvenColor: '#2e7d32',
    deltaTimeColor: '#ffeb3b',
    attemptColor: '#ffffff',
    attemptBackgroundColor: '#388e3c',
    laneColor: '#ffffff',
    numberColor: '#ffffff',
    lastLapTimeColor: '#ffffff',
    reactionTimeColor: '#ffffff',
    lapsToGoColor: '#ffffff',
    lapsColumnsColor: '#ffffff',
    failColor: '#f44336',
    passColor: '#2196f3',
    successColor: '#4caf50',
    // Tipografía
    headerFontFamily: 'Oswald',
    nameFontFamily: 'Oswald',
    numbersFontFamily: 'IBM Plex Mono'
  },
  
  digital: {
    // Colores
    tableBackgroundColor: '#000000',
    globalFontColor: '#00ff00',
    headerBackgroundColor: '#0f0f0f',
    headerFontColor: '#00ff00',
    columnsHeaderColor: '#1a1a1a',
    positionColor: '#00ff00',
    positionBackgroundColor: '#1a1a1a',
    nameBackgroundColor: '#1a1a1a',
    athleteNameColor: '#00ff00',
    teamNameColor: '#00bb00',
    markBackgroundColor: '#000000',
    resultTimeColor: '#00ff00',
    timerColor: '#00ff00',
    largeTimerColor: '#00ff00',
    tableRowOddColor: '#000000',
    tableRowEvenColor: '#0a0a0a',
    deltaTimeColor: '#00ffff',
    attemptColor: '#00ff00',
    attemptBackgroundColor: '#0f0f0f',
    laneColor: '#00ff00',
    numberColor: '#00ff00',
    lastLapTimeColor: '#00ff00',
    reactionTimeColor: '#00ff00',
    lapsToGoColor: '#00ff00',
    lapsColumnsColor: '#00ff00',
    failColor: '#ff0000',
    passColor: '#0000ff',
    successColor: '#00ff00',
    // Tipografía
    headerFontFamily: 'Courier New',
    nameFontFamily: 'Courier New',
    numbersFontFamily: 'transist'
  },
  
  highContrast: {
    // Colores
    tableBackgroundColor: '#000000',
    globalFontColor: '#ffff00',
    headerBackgroundColor: '#000000',
    headerFontColor: '#ffff00',
    columnsHeaderColor: '#333333',
    positionColor: '#ffff00',
    positionBackgroundColor: '#000000',
    nameBackgroundColor: '#000000',
    athleteNameColor: '#ffff00',
    teamNameColor: '#ffffff',
    markBackgroundColor: '#000000',
    resultTimeColor: '#ffff00',
    timerColor: '#ffff00',
    largeTimerColor: '#ffff00',
    tableRowOddColor: '#000000',
    tableRowEvenColor: '#333333',
    deltaTimeColor: '#ffffff',
    attemptColor: '#ffff00',
    attemptBackgroundColor: '#333333',
    laneColor: '#ffff00',
    numberColor: '#ffff00',
    lastLapTimeColor: '#ffff00',
    reactionTimeColor: '#ffff00',
    lapsToGoColor: '#ffff00',
    lapsColumnsColor: '#ffff00',
    failColor: '#ff0000',
    passColor: '#0000ff',
    successColor: '#00ff00',
    // Tipografía
    headerFontFamily: 'Arial',
    nameFontFamily: 'Arial',
    numbersFontFamily: 'Courier New'
  },
  
  nightMode: {
    // Colores
    tableBackgroundColor: '#000000',
    globalFontColor: '#bb0000',
    headerBackgroundColor: '#1a1a1a',
    headerFontColor: '#bb0000',
    columnsHeaderColor: '#1a1a1a',
    positionColor: '#bb0000',
    positionBackgroundColor: '#1a1a1a',
    nameBackgroundColor: '#1a1a1a',
    athleteNameColor: '#bb0000',
    teamNameColor: '#880000',
    markBackgroundColor: '#000000',
    resultTimeColor: '#bb0000',
    timerColor: '#bb0000',
    largeTimerColor: '#bb0000',
    tableRowOddColor: '#000000',
    tableRowEvenColor: '#0a0a0a',
    deltaTimeColor: '#ff0000',
    attemptColor: '#bb0000',
    attemptBackgroundColor: '#1a1a1a',
    laneColor: '#bb0000',
    numberColor: '#bb0000',
    lastLapTimeColor: '#bb0000',
    reactionTimeColor: '#bb0000',
    lapsToGoColor: '#bb0000',
    lapsColumnsColor: '#bb0000',
    failColor: '#ff0000',
    passColor: '#660000',
    successColor: '#990000',
    // Tipografía
    headerFontFamily: 'Courier New',
    nameFontFamily: 'Courier New',
    numbersFontFamily: 'transist'
  },
  
  modern: {
    // Colores
    tableBackgroundColor: '#263238',
    globalFontColor: '#eceff1',
    headerBackgroundColor: '#37474f',
    headerFontColor: '#eceff1',
    columnsHeaderColor: '#455a64',
    positionColor: '#eceff1',
    positionBackgroundColor: '#455a64',
    nameBackgroundColor: '#455a64',
    athleteNameColor: '#eceff1',
    teamNameColor: '#b0bec5',
    markBackgroundColor: '#263238',
    resultTimeColor: '#4fc3f7',
    timerColor: '#4fc3f7',
    largeTimerColor: '#4fc3f7',
    tableRowOddColor: '#263238',
    tableRowEvenColor: '#37474f',
    deltaTimeColor: '#4fc3f7',
    attemptColor: '#eceff1',
    attemptBackgroundColor: '#455a64',
    laneColor: '#eceff1',
    numberColor: '#eceff1',
    lastLapTimeColor: '#eceff1',
    reactionTimeColor: '#eceff1',
    lapsToGoColor: '#eceff1',
    lapsColumnsColor: '#eceff1',
    failColor: '#ef5350',
    passColor: '#42a5f5',
    successColor: '#66bb6a',
    // Tipografía
    headerFontFamily: 'Inter',
    nameFontFamily: 'Inter',
    numbersFontFamily: 'SCOREBOARD'
  },
  
  retro: {
    // Colores
    tableBackgroundColor: '#3e2723',
    globalFontColor: '#ffcc80',
    headerBackgroundColor: '#4e342e',
    headerFontColor: '#ffcc80',
    columnsHeaderColor: '#5d4037',
    positionColor: '#ffcc80',
    positionBackgroundColor: '#5d4037',
    nameBackgroundColor: '#5d4037',
    athleteNameColor: '#ffcc80',
    teamNameColor: '#d7ccc8',
    markBackgroundColor: '#3e2723',
    resultTimeColor: '#ffcc80',
    timerColor: '#ffcc80',
    largeTimerColor: '#ffcc80',
    tableRowOddColor: '#3e2723',
    tableRowEvenColor: '#4e342e',
    deltaTimeColor: '#ffcc80',
    attemptColor: '#ffcc80',
    attemptBackgroundColor: '#5d4037',
    laneColor: '#ffcc80',
    numberColor: '#ffcc80',
    lastLapTimeColor: '#ffcc80',
    reactionTimeColor: '#ffcc80',
    lapsToGoColor: '#ffcc80',
    lapsColumnsColor: '#ffcc80',
    failColor: '#ff7043',
    passColor: '#5d4037',
    successColor: '#8d6e63',
    // Tipografía
    headerFontFamily: 'Courier New',
    nameFontFamily: 'monospace',
    numbersFontFamily: 'SCOREBOARD'
  },
  
  athletics: {
    // Colores
    tableBackgroundColor: '#b71c1c',
    globalFontColor: '#ffffff',
    headerBackgroundColor: '#c62828',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#d32f2f',
    positionColor: '#ffffff',
    positionBackgroundColor: '#d32f2f',
    nameBackgroundColor: '#d32f2f',
    athleteNameColor: '#ffffff',
    teamNameColor: '#ffcdd2',
    markBackgroundColor: '#b71c1c',
    resultTimeColor: '#ffffff',
    timerColor: '#ffeb3b',
    largeTimerColor: '#ffeb3b',
    tableRowOddColor: '#b71c1c',
    tableRowEvenColor: '#c62828',
    deltaTimeColor: '#ffeb3b',
    attemptColor: '#ffffff',
    attemptBackgroundColor: '#d32f2f',
    laneColor: '#ffffff',
    numberColor: '#ffffff',
    lastLapTimeColor: '#ffffff',
    reactionTimeColor: '#ffffff',
    lapsToGoColor: '#ffffff',
    lapsColumnsColor: '#ffffff',
    failColor: '#b71c1c',
    passColor: '#0d47a1',
    successColor: '#1b5e20',
    // Tipografía
    headerFontFamily: 'Oswald',
    nameFontFamily: 'Roboto',
    numbersFontFamily: 'CodaHeavy'
  },
  
  soccer: {
    // Colores
    tableBackgroundColor: '#388e3c',
    globalFontColor: '#ffffff',
    headerBackgroundColor: '#2e7d32',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#43a047',
    positionColor: '#ffffff',
    positionBackgroundColor: '#43a047',
    nameBackgroundColor: '#43a047',
    athleteNameColor: '#ffffff',
    teamNameColor: '#c8e6c9',
    markBackgroundColor: '#388e3c',
    resultTimeColor: '#ffffff',
    timerColor: '#ffeb3b',
    largeTimerColor: '#ffeb3b',
    tableRowOddColor: '#388e3c',
    tableRowEvenColor: '#2e7d32',
    deltaTimeColor: '#ffeb3b',
    attemptColor: '#ffffff',
    attemptBackgroundColor: '#43a047',
    laneColor: '#ffffff',
    numberColor: '#ffffff',
    lastLapTimeColor: '#ffffff',
    reactionTimeColor: '#ffffff',
    lapsToGoColor: '#ffffff',
    lapsColumnsColor: '#ffffff',
    failColor: '#b71c1c',
    passColor: '#0d47a1',
    successColor: '#1b5e20',
    // Tipografía
    headerFontFamily: 'Oswald',
    nameFontFamily: 'Montserrat',
    numbersFontFamily: 'Roboto Mono'
  },
  
  tennis: {
    // Colores
    tableBackgroundColor: '#2e7d32',
    globalFontColor: '#ffffff',
    headerBackgroundColor: '#388e3c',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#43a047',
    positionColor: '#ffffff',
    positionBackgroundColor: '#ff9800',
    nameBackgroundColor: '#43a047',
    athleteNameColor: '#ffffff',
    teamNameColor: '#c8e6c9',
    markBackgroundColor: '#2e7d32',
    resultTimeColor: '#ffeb3b',
    timerColor: '#ffeb3b',
    largeTimerColor: '#ffeb3b',
    tableRowOddColor: '#2e7d32',
    tableRowEvenColor: '#388e3c',
    deltaTimeColor: '#ffeb3b',
    attemptColor: '#ffffff',
    attemptBackgroundColor: '#43a047',
    laneColor: '#ffffff',
    numberColor: '#ffffff',
    lastLapTimeColor: '#ffffff',
    reactionTimeColor: '#ffffff',
    lapsToGoColor: '#ffffff',
    lapsColumnsColor: '#ffffff',
    failColor: '#e53935',
    passColor: '#1976d2',
    successColor: '#43a047',
    // Tipografía
    headerFontFamily: 'Raleway',
    nameFontFamily: 'Raleway',
    numbersFontFamily: 'CodaHeavy'
  },
  
  swimming: {
    // Colores
    tableBackgroundColor: '#0277bd',
    globalFontColor: '#ffffff',
    headerBackgroundColor: '#0288d1',
    headerFontColor: '#ffffff',
    columnsHeaderColor: '#039be5',
    positionColor: '#ffffff',
    positionBackgroundColor: '#039be5',
    nameBackgroundColor: '#039be5',
    athleteNameColor: '#ffffff',
    teamNameColor: '#b3e5fc',
    markBackgroundColor: '#0277bd',
    resultTimeColor: '#ffffff',
    timerColor: '#ffeb3b',
    largeTimerColor: '#ffeb3b',
    tableRowOddColor: '#0277bd',
    tableRowEvenColor: '#0288d1',
    deltaTimeColor: '#ffeb3b',
    attemptColor: '#ffffff',
    attemptBackgroundColor: '#039be5',
    laneColor: '#ffffff',
    numberColor: '#ffffff',
    lastLapTimeColor: '#ffffff',
    reactionTimeColor: '#ffffff',
    lapsToGoColor: '#ffffff',
    lapsColumnsColor: '#ffffff',
    failColor: '#e53935',
    passColor: '#1565c0',
    successColor: '#2e7d32',
    // Tipografía
    headerFontFamily: 'Montserrat',
    nameFontFamily: 'Roboto',
    numbersFontFamily: 'SCOREBOARD'
  }
};